import axios from "axios";
import Picker from "emoji-picker-react";
import i18next from "i18next";
import moment from "moment";
import React from "react";
import { BsCloudDownload, BsSearch } from "react-icons/bs";
import ReactPlayer from "react-player";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ProfileService from "../../../../api/ProfileService";
import { API_URL, CHAT_URL, JITSI_URL } from "../../../../config/app-config";
import i18n from "../../../../i18n";
import AuthService from "../../../../session/AuthService_old";
import { generateUlr } from "../../../../utils";
import dummy_image from "../../assets/img/default_avatar.jpg";
import { InstantMeetingAction } from "../../store/actions/MessengerAction";
import "./chatItembox.css";
import ScheduleForm from "./scheduleForm";

function GroupItemBox({
  t,
  handleChatListBoxClose,
  selectedGroup,
  user,
  socket,
  selectedGroupMembers,
  messages,
  updateGrouMessageData,
  onSearchChange,
}) {
  const dispatch = useDispatch();
  const divref = React.useRef(null);
  const textRef = React.useRef(null);

  const [isEmojiOpen, setIsEmojiOpen] = React.useState(false);
  const [isMeetingPanelOpen, setIsMeetingPanelOpen] = React.useState(false);
  const [isHovering, setIsHovering] = React.useState(false);
  const [isSchduleHovering, setIsSchduleHovering] = React.useState(false);
  const [showScheduledMeeting, setShowScheduledMeeting] = React.useState(false);
  const [replyToMessage, setReplyToMessage] = React.useState(null);
  const [hoveredIndex, setHoveredIndex] = React.useState(null);
  const [replyingToIndex, setReplyingToIndex] = React.useState(null);
  const [searchText, setSearchText] = React.useState("");

  const messagesById = React.useMemo(() => {
    const map = {};
    messages.forEach((m) => {
      map[m._id] = m;
    });
    return map;
  }, [messages]);

  const { messageSendSuccess } = useSelector(
    (state) => state.messenger,
    shallowEqual
  );

  console.group("Memoized State : GroupItemBox Props");
  console.log("User Details :", user);
  console.log("Selected Group :", selectedGroup);
  console.log("Messages :", messages);
  console.groupEnd();

  const [newMessage, setNewMessage] = React.useState("");

  // Format message time like WhatsApp
  const formatMessageTime = (timestamp) => {
    const messageDate = moment(timestamp);
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'days').startOf('day');

    if (messageDate.isSame(today, 'd')) {
      return messageDate.format('h:mm A');
    } else if (messageDate.isSame(yesterday, 'd')) {
      return `Yesterday, ${messageDate.format('h:mm A')}`;
    } else if (messageDate.isSame(today, 'week')) {
      return `${messageDate.format('dddd')}, ${messageDate.format('h:mm A')}`;
    } else {
      return messageDate.format('MM/DD/YYYY, h:mm A');
    }
  };

  const messagePayload = (message, isMeeting = false) => {
    return {
      senderName: user.dName,
      senderId: user.uId,
      message: message,
      isMeeting: isMeeting,
    };
  };

  const handleShowMeeting = (e) => {
    setIsMeetingPanelOpen(!isMeetingPanelOpen);
  };

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  const handleSchduleMouseEnter = () => {
    setIsSchduleHovering(true);
  };

  const handleSchduleMouseLeave = () => {
    setIsSchduleHovering(false);
  };

  const handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      setNewMessage((prevText) => prevText + "\n");
    }
  };

  const handleReplyClick = (index) => {
    setReplyingToIndex(index);
    setNewMessage("");
    setTimeout(() => {
      if (textRef.current) textRef.current.focus();
    }, 100);
  };

  const sendGroupMessage = async () => {
    const replyToId = replyingToIndex !== null ? messages[replyingToIndex]._id : null;

    try {
      const messageData = {
        senderId: user.uId,
        senderName: user.dName,
        groupId: selectedGroup._id,
        replyTo: replyToId,
        message: { text: newMessage.trim() },
        isGroupMessage: true,
      };

      setNewMessage("");
      setIsEmojiOpen(false);
      setReplyingToIndex(null);

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const response = await axios.post(
        `${CHAT_URL}api/sendMessage`,
        messageData,
        config
      );

      let deliverData = {
        ...response.data.data,
        isGroupMessage: true,
        selectedGroup: selectedGroup.members,
      };

      updateGrouMessageData(deliverData);
      console.log("Group message sent successfully:", messageData);
    } catch (error) {
      console.error("Failed to send group message:", error);
      toast.error("Failed to send message");
    }
  };

  const handleEmoji = (e, { emoji }) => {
    const ref = textRef.current;
    ref.focus();
    const start = newMessage.substring(0, ref.selectionStart);
    const end = newMessage.substring(ref.selectionStart);
    const newText = start + emoji + end;
    setNewMessage(newText);
  };

  const handleScheduledMeeting = (data) => {
    const message = { meeting: data };
    const formData = messagePayload(message, true);
    dispatch(InstantMeetingAction(formData));
  };

  const handleClose = () => {
    setShowScheduledMeeting(false);
  };

  const ImageSend = async (e) => {
    const formdata = new FormData();
    const allowedfileType = [
      "text/csv",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/pdf",
      "application/docx",
      "application/plain",
      "image/jpeg",
      "image/png",
      "image/webp",
      "video/mp4",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    let validFileAdded = false;

    for (let i = 0; i < e.target.files.length; i++) {
      if (allowedfileType.includes(e.target.files[i].type)) {
        formdata.append("files", e.target.files[i]);
        validFileAdded = true;
      } else {
        toast.warning(`File type ${e.target.files[i].type} is not supported`);
      }
    }

    if (!validFileAdded) return;

    formdata.append("senderName", user.dName);
    formdata.append("senderId", user.uId);
    formdata.append("receiverId", selectedGroup._id);

    try {
      const response = await axios.post(
        `${CHAT_URL}api/message/groupImage`,
        formdata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const deliverData = {
        ...response.data.data,
        isGroupMessage: true,
        selectedGroup: selectedGroup.members,
      };

      updateGrouMessageData(deliverData);
      console.log("Image sent successfully:", deliverData);
    } catch (err) {
      console.error("Image upload failed:", err);
      toast.error("Image send failed");
    }
  };

  React.useEffect(() => {
    if (messageSendSuccess) {
      socket.current.emit("sendMessage", messages[messages.length - 1]);
      dispatch({
        type: "UPDATE_FRIEND_MESSAGE",
        payload: messages[messages.length - 1],
        isNotOwner: true,
      });
      dispatch({
        type: "CLEAR_MESSAGE_SEND_SUCCEESS",
        payload: false,
      });
    }
  }, [messageSendSuccess]);

  React.useEffect(() => {
    let langValue = AuthService.getCommonLanguages();
    i18n.changeLanguage(langValue);
  }, []);

  React.useEffect(() => {
    divref.current?.scrollIntoView({ block: "end", behavior: "smooth" });
  }, [messages]);

  const OpenEmojiContainer = () => {
    setIsEmojiOpen(!isEmojiOpen);
  };

  const handleShowModalScreen = () => {
    setIsMeetingPanelOpen(false);
    setShowScheduledMeeting(true);
  };

  const handleSetModalScreenClose = () => {
    setShowScheduledMeeting(false);
  };

  // Function to get message preview for reply
  const getMessagePreview = (message) => {
    if (message.message?.text?.length > 0) {
      return message.message.text.length > 60
        ? message.message.text.substring(0, 60) + '...'
        : message.message.text;
    } else if (message.message?.image?.length > 0) {
      return "📎 File";
    } else if (message.isMeeting) {
      return "📅 Meeting";
    }
    return "Message";
  };

  console.log("Members List : ", selectedGroup)

  return (
    <div className="chatItemBox-container">
      {/* Header */}
      <div className="chatItemBox--header">
        <div className="chatItemBox-img-container">
          <div className="group-avatar">
            <span className="group-avatar-text">
              {selectedGroup?.name?.charAt(0)?.toUpperCase() || 'G'}
            </span>
          </div>
          <div className="group-info">
            <span className="chatItemBox-header-username">
              {selectedGroup?.name}
            </span>
            <span className="group-members-count">
              {selectedGroup?.members.length || 0} members
            </span>
          </div>
        </div>
        <div className="chatItemBox-icons-container">
          <div onClick={() => handleChatListBoxClose()} className="chatItemBox-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              data-supported-dps="16x16"
              fill="currentColor"
              width="16"
              height="16"
              focusable="false"
            >
              <path d="M14 3.41L9.41 8 14 12.59 12.59 14 8 9.41 3.41 14 2 12.59 6.59 8 2 3.41 3.41 2 8 6.59 12.59 2z"></path>
            </svg>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="chatItemBox--body">
        {/* Search Bar */}
        <div className="chatItemBox-search-container">
          <BsSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search messages…"
            value={searchText}
            onChange={(e) => {
              const value = e.target.value;
              setSearchText(value);
              onSearchChange(value);
            }}
            className="chatItemBox-search-input"
          />
        </div>

        <div className="chatItemBox-message-list">
          {messages && messages.length > 0 ? (
            messages.map((message, index) => {
              const repliedMsg = message.replyTo ? messagesById[message.replyTo] : null;
              const isOwnMessage = +message.senderId === +user.uId;

              return (
                <div
                  key={message._id}
                  className={`chatItemBox-message-item ${isOwnMessage ? "chatItemBox-message-sent" : "chatItemBox-message-received"
                    }`}
                  ref={divref}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <img
                    src={
                      message?.senderId && message?.senderName
                        ? message.senderId === user?.uId
                          ? `data:image/jpeg;base64,${user?.uPhoto}`
                          : `${API_URL}/api/getUserPhoto/${message?.senderId}/${message?.senderName}`
                        : dummy_image
                    }
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = dummy_image;
                    }}
                    alt="avatar"
                    className="chatItemBox-message-avatar"
                  />

                  <div className="chatItemBox-message-content">
                    {/* Message Meta */}
                    <div className="chatItemBox-message-meta">
                      <span className="chatItemBox-message-username">
                        {isOwnMessage ? "You" : message?.senderName}
                      </span>
                      <span className="chatItemBox-message-time">
                        {formatMessageTime(message.created_at)}
                      </span>
                    </div>

                    {/* Reply Preview */}
                    {repliedMsg && (
                      <div className="chatItemBox-reply-preview">
                        <div className="reply-indicator"></div>
                        <div className="reply-content">
                          <span className="reply-sender">
                            {repliedMsg.senderName}
                          </span>
                          <span className="reply-text">
                            {getMessagePreview(repliedMsg)}
                          </span>
                        </div>
                      </div>
                    )}

                    {/* Message Content */}
                    {message.message.text.length === 0 && !message.isMeeting ? (
                      <div className="chatItemBox-message-media-list">
                        {message.message.image.map((image, imgIndex) => {
                          const imageTypeList = ["png", "jpg", "jpeg", "gif"];
                          const document = ["pdf", "txt"];
                          const imageTypeIndex = image.lastIndexOf(".");
                          const imageType = image.substring(imageTypeIndex + 1).toLowerCase();
                          const isImageType = imageTypeList.includes(imageType);
                          const isDocument = document.includes(imageType);

                          if (isImageType) {
                            return (
                              <a
                                key={imgIndex}
                                href={`${CHAT_URL}api/getImage/${image}`}
                                download
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src={`${CHAT_URL}api/getImage/${image}`}
                                  alt="Shared content"
                                  className="chatItemBox-msg-img"
                                />
                              </a>
                            );
                          } else if (isDocument) {
                            return (
                              <div key={imgIndex} className="chatItemBox-file-box">
                                <a
                                  href={`${CHAT_URL}api/getImage/${image}`}
                                  download
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <BsCloudDownload size="2em" color="#1976d2" />
                                </a>
                                <a
                                  href={`${CHAT_URL}api/getImage/${image}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="chatItemBox-file-link"
                                >
                                  View document
                                </a>
                              </div>
                            );
                          } else {
                            return (
                              <div key={imgIndex}>
                                <ReactPlayer
                                  className="player"
                                  controls
                                  width="100%"
                                  height="200px"
                                  url={`${CHAT_URL}api/getImage/${image}`}
                                />
                              </div>
                            );
                          }
                        })}
                      </div>
                    ) : message.message.text.length > 0 && !message.isMeeting ? (
                      <div className="chatItemBox-message-text">
                        {message.message.text}
                      </div>
                    ) : message.isMeeting ? (
                      <div
                        className="chatItemBox-meeting-box"
                        onClick={() =>
                          generateUlr(
                            `${JITSI_URL}${message?.message?.meeting?.meetingLink}?authenticated=true&sp=yes`
                          )
                        }
                      >
                        <div className="meeting-content">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16 16"
                            data-supported-dps="16x16"
                            fill="currentColor"
                            width="20"
                            height="20"
                            focusable="false"
                          >
                            <path d="M1 5v6a2 2 0 002 2h8V3H3a2 2 0 00-2 2zm4 0h2v2h2v2H7v2H5V9H3V7h2zm10-1v8h-1.5l-1.5-.75v-6.5L13.5 4z"></path>
                          </svg>
                          <div>
                            {message?.message?.meeting?.meetingType === "Scheduled" ? (
                              <>
                                <div className="chatItemBox-meeting-title">
                                  {message?.message?.meeting?.meetingName || "Join Meeting"}
                                </div>
                                <div className="chatItemBox-meeting-info">
                                  {moment(message?.message?.meeting?.meetingTime)
                                    .locale("en")
                                    .format("MMM DD, YYYY, h:mm A")}
                                </div>
                                <div className="chatItemBox-meeting-info">
                                  {message?.message?.meeting?.isMeetingfinished
                                    ? "Meeting Ended"
                                    : "Join Video Meeting"}
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="chatItemBox-meeting-title">
                                  Group Meeting
                                </div>
                                <div className="chatItemBox-meeting-info">
                                  {message?.message?.meeting?.isMeetingfinished
                                    ? "Meeting Ended"
                                    : "Join Video Meeting"}
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {/* Reply Button */}
                    {hoveredIndex === index && (
                      <div className="chatItemBox-message-actions">
                        <button
                          className="reply-button"
                          onClick={() => handleReplyClick(index)}
                          title="Reply to message"
                          style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            padding: "4px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            fill="currentColor"
                          >
                            <path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.5 11 5.1-1-5-4-10-11-11z" />
                          </svg>
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="chatItemBox-empty-state">
              <div className="empty-state-icon">💬</div>
              <p>No messages yet</p>
              <span>Start the conversation by sending a message</span>
            </div>
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="chatItemBox--footer">
        {showScheduledMeeting && (
          <ScheduleForm
            handleSchduledMeeting={handleScheduledMeeting}
            loginedUserDetails={user}
            showModalScreen={handleScheduledMeeting}
            handleClose={handleClose}
            handleModalScreenVisibility={handleSetModalScreenClose}
          />
        )}

        {/* Reply Preview */}
        {replyingToIndex !== null && messages[replyingToIndex] && (
          <div className="chatItemBox-reply-preview-bar">
            <div className="reply-preview-content">
              <span className="replying-to-text">Replying to:</span>
              <span className="reply-preview-text">
                {getMessagePreview(messages[replyingToIndex])}
              </span>
            </div>
            <button
              className="cancel-reply-button"
              onClick={() => setReplyingToIndex(null)}
            >
              ×
            </button>
          </div>
        )}

        <div className="chatItemBox--footer-text-box">
          <textarea
            ref={textRef}
            placeholder="Type a message..."
            value={newMessage}
            onKeyPress={handleKeyPress}
            onChange={(e) => setNewMessage(e.target.value)}
            className="chatItemBox-textarea"
          ></textarea>
        </div>

        <div className="chatItemBox--footer-send-box">
          <div className="chatItemBox--footer-emoji-container">
            <div>
              <label htmlFor="group-file-input" className="chatItemBox-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  data-supported-dps="16x16"
                  fill="currentColor"
                  width="16"
                  height="16"
                  focusable="false"
                >
                  <path d="M14 3H2a1 1 0 00-1 1v8a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1zM3 11l3-2.95L9 11H3zm10 0h-2.77L6.31 7.13a.44.44 0 00-.62 0L3 9.77V5h10v6zm-2.5-2A1.5 1.5 0 109 7.5 1.5 1.5 0 0010.5 9zm0-2.25a.75.75 0 11-.75.75.75.75 0 01.75-.75z"></path>
                </svg>
              </label>
              <input
                onChange={ImageSend}
                type="file"
                name="file"
                id="group-file-input"
                multiple
                style={{ display: "none" }}
              />
            </div>

            <div onClick={OpenEmojiContainer} className="chatItemBox-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                data-supported-dps="16x16"
                fill="currentColor"
                width="16"
                height="16"
                focusable="false"
              >
                <path d="M4.84 6A1.16 1.16 0 116 7.17 1.17 1.17 0 014.84 6zM8 9.38a3.51 3.51 0 01-2.3-.81l-.83 1.29a4.87 4.87 0 006.25 0l-.82-1.28a3.51 3.51 0 01-2.3.8zm2-4.55A1.17 1.17 0 1011.16 6 1.17 1.17 0 0010 4.83zM8 2.88A5.12 5.12 0 112.88 8 5.12 5.12 0 018 2.88M8 1a7 7 0 107 7 7 7 0 00-7-7z"></path>
              </svg>
            </div>
          </div>

          <button
            disabled={newMessage.trim().length === 0}
            onClick={sendGroupMessage}
            className="chatItemBox-send-btn"
          >
            Send
          </button>
        </div>
      </div>

      {/* Emoji Picker */}
      {isEmojiOpen && (
        <div className="chatItemBox-emoji-picker">
          <Picker
            onEmojiClick={handleEmoji}
            disableAutoFocus={true}
            groupNames={{ smileys_people: "PEOPLE" }}
            native
          />
        </div>
      )}
    </div>
  );
}

export default GroupItemBox;